// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".edit-dialog .el-input__inner {\n  width: 370px;\n}\n.edit-dialog .el-input-number {\n  width: 370px;\n}\n.edit-dialog .picture {\n  border-radius: 4px;\n  border: 1px solid #dcdfe6;\n  width: 370px;\n  padding: 10px;\n  height: 200px;\n}\n.edit-dialog .el-input__count {\n  line-height: 12px;\n}", ""]);
// Exports
module.exports = exports;
